/**
 * Masquage des badges de menu (« Nouveau » / pastille dorée).
 *
 * Un badge disparaît une fois que l'utilisateur a VISITÉ la page cible
 * (pas au simple clic) : à chaque chargement, si l'URL courante correspond à
 * l'URL cible d'un badge, ce badge est masqué et mémorisé (localStorage).
 * Visiter la page d'un enfant masque aussi le badge du parent qui le contient.
 *
 * Le masquage effectif passe par une feuille de style globale injectée (règles
 * `display:none` ciblées par clé+version) — voir aussi snippets/menu-badge-head
 * qui l'injecte tôt dans le <head> pour éviter tout flash.
 *
 * Dans l'éditeur de thème (design mode), les badges restent toujours visibles.
 * Réinitialisation interne via le paramètre d'URL `?reset-menu-badges`.
 */
(function () {
  var STORAGE_KEY = 'nooance:menu-badge:dismissed';
  var STYLE_ID = 'menu-badge-dismissed-style';
  var RESET_PARAM = 'reset-menu-badges';

  function readStore() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeStore(store) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {
      /* quota / mode privé : on ignore */
    }
  }

  function inDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Échappe une chaîne pour l'insérer dans un sélecteur d'attribut CSS "...".
  function cssString(value) {
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  // Normalise une URL en chemin comparable (sans origine, query, hash ni / final).
  function normalizePath(url) {
    try {
      var p = new URL(url, window.location.origin).pathname;
      p = decodeURIComponent(p);
      if (p.length > 1) p = p.replace(/\/+$/, '');
      return p;
    } catch (e) {
      return null;
    }
  }

  function styleEl() {
    var el = document.getElementById(STYLE_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = STYLE_ID;
      (document.head || document.documentElement).appendChild(el);
    }
    return el;
  }

  // (Re)génère la feuille de style de masquage à partir du localStorage.
  function refresh() {
    var el = styleEl();
    if (inDesignMode()) {
      el.textContent = '';
      return;
    }
    var store = readStore();
    var rules = '';
    for (var key in store) {
      if (!Object.prototype.hasOwnProperty.call(store, key)) continue;
      var ver = store[key];
      rules +=
        '.menu-badge-group[data-badge-key="' +
        cssString(key) +
        '"][data-badge-ver="' +
        cssString(ver) +
        '"]{display:none !important;}';
    }
    el.textContent = rules;
  }

  function markGroups(scope, store) {
    var groups = scope.querySelectorAll('.menu-badge-group[data-badge-key]');
    for (var i = 0; i < groups.length; i++) {
      store[groups[i].getAttribute('data-badge-key')] = groups[i].getAttribute('data-badge-ver') || '';
    }
  }

  // Quand un badge enfant est masqué, on masque aussi le badge du parent qui le
  // contient (remontée DOM), à chaque niveau :
  //   - desktop méga-menu : parent = lien top-level du `.menu-list__list-item`
  //   - drawer mobile      : parent = `summary` de l'accordéon `details` englobant
  function markAncestorParents(badgeEl, store) {
    var li = badgeEl.closest('.menu-list__list-item');
    while (li) {
      var parentLink = li.querySelector(':scope > a.menu-list__link, :scope > .menu-list__link');
      if (parentLink) markGroups(parentLink, store);
      li = li.parentElement ? li.parentElement.closest('.menu-list__list-item') : null;
    }
    var details = badgeEl.closest('details');
    while (details) {
      var summary = details.querySelector(':scope > summary');
      if (summary) markGroups(summary, store);
      details = details.parentElement ? details.parentElement.closest('details') : null;
    }
  }

  // Au chargement : masque les badges dont la page cible correspond à l'URL
  // courante (= page visitée), et remonte au(x) parent(s).
  function applyVisits() {
    if (inDesignMode()) return;
    var current = normalizePath(window.location.href);
    if (!current) return;
    var store = readStore();
    var changed = false;
    var groups = document.querySelectorAll('.menu-badge-group[data-badge-url]');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var target = normalizePath(g.getAttribute('data-badge-url'));
      if (!target || target !== current) continue;
      var key = g.getAttribute('data-badge-key');
      if (key) store[key] = g.getAttribute('data-badge-ver') || '';
      markAncestorParents(g, store);
      changed = true;
    }
    if (changed) {
      writeStore(store);
      refresh();
    }
  }

  function maybeReset() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (!params.has(RESET_PARAM)) return;
      localStorage.removeItem(STORAGE_KEY);
      // On retire le paramètre de l'URL pour ne pas re-réinitialiser au rechargement.
      params.delete(RESET_PARAM);
      var qs = params.toString();
      var newUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState({}, document.title, newUrl);
    } catch (e) {
      /* localStorage / history indispo : on ignore */
    }
  }

  function onReady() {
    refresh();
    applyVisits();
  }

  maybeReset();
  refresh();

  if (document.readyState !== 'loading') {
    onReady();
  } else {
    document.addEventListener('DOMContentLoaded', onReady);
  }
  document.addEventListener('shopify:section:load', onReady);
})();
